<!------------------------------------------------------------------------------
 File: BaseSwitchEvents 
------------------------------------------------------------------------------->
<template>
    <div class="no-gutters" :class="{
    'row':row
    }">
        <div v-if="typeof label !== 'undefined' && label !== null"
             class="col-sm-12 col-md-4 text-sentence"
        >{{label}}
        </div>
        <div class="show-status">
            <div :class="status"
                @click="status_change">
                {{status}}
            </div>
        </div>
        <div :class="{
                    'col-sm-12 col-md-8':typeof label !== 'undefined' && label !== null && row,
                    'col':typeof label == 'undefined' && row || label == null && row
                }">
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import vueTooltip from './tooltip/vueTooltip';

    Vue.use(vueTooltip);

    export default {
        name: "BaseSwitchEvents",
        components: {},
        props: {
            tabindex: {
                type: Number
            },
            cls: {
                type: String
            },
            row: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default:null
            },
            field: {
                type: String,
                default: 'status'
            },
            status: {
                type: String
            },
            switch_off: {
                type: String,
                default: 'off'
            },
            switch_on: {
                type: String,
                default: 'on'
            },
            title: {
                type: String,
                default: null
            },
            tooltip: {
                type: Boolean,
                default: true
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
        },
        data() {
            return {}
        },
        methods: {
            status_change: function() {
                let self = this;

                let newStatus = (this.status == 'active') ? 'inactive' : 'active';
                this.$emit('status_change', newStatus);
            }
        },
        watch: {},
        computed: {}
    }
</script>

<style scoped>

    .show-status div {
        background-color:#fff;
        padding:2px 5px;
        border-radius:4px;
        border:solid 1px #ccc;
        cursor:pointer;
    }
    .show-status .inactive {
        background-color:#f2dede !important;
        /* #f2dede */
    }
    .show-status .active {
        background-color:#dff0d8 !important;
        /* #dff0d8 */
    }
</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseSwitchEvents.vue?5ade5cb4